// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_Wq1","top":"styles_top__1vu_v","left":"styles_left__36nkq","description":"styles_description__2WxuL"};